const searchResultsBlock = (() => {

    // Toggle filter & sort overlays
    const handleToggleOverlays = el => {
        const filters = el.querySelector('[data-results-filters]');
        el.querySelectorAll('[data-toggle-filters]').forEach(toggle => {
            toggle.addEventListener('click', () => {
                filters.classList.toggle('search-results-block__filters--open');
                document.documentElement.classList.toggle('overlay--filters');
            });
        });

        const sort = el.querySelector('[data-results-sort]');
        el.querySelectorAll('[data-toggle-sort]').forEach(toggle => {
            toggle.addEventListener('click', () => {
                sort.classList.toggle('search-results-block__sort--open');
                document.documentElement.classList.toggle('overlay--filters');
            });
        });
    };

    // Toggle list / map view (if maps exist)
    const handleMapToggle = el => {
        el.querySelectorAll('[data-toggle-map-view]').forEach(toggle => {
            const listWrapper = el.querySelector('[data-results-list]');
            const mapWrapper = el.querySelector('[data-results-map]');

            toggle.addEventListener('click', () => {
                const text = toggle.querySelector('span[data-view-toggle-text]');
                const mapHideEls = el.querySelectorAll('[data-map-hide]');

                const showMap = text.dataset.viewToggleText === 'Map ';

                listWrapper.classList.toggle('hidden', showMap);
                mapWrapper.classList.toggle('hidden', !showMap);
                text.dataset.viewToggleText = showMap ? 'List ' : 'Map ';

                mapHideEls.forEach(el => el.classList.toggle('hidden', showMap));

                el.classList.toggle('map-view', showMap);
                el.querySelectorAll('[data-icon-map]').forEach(i => i.classList.toggle('hidden', showMap));
                el.querySelectorAll('[data-icon-list]').forEach(i => i.classList.toggle('hidden', !showMap));

                window.scrollTo(0, 0);
            });
        });
    };

    // Bind paging (if JS pagination still used)
    const bindPaging = scope => {
        const paging = scope.querySelector('.pagination:not(.nobinding)');
        if (!paging) return;

        const prev = paging.querySelector('[title="Previous Page"]');
        const next = paging.querySelector('[title="Next Page"]');

        if (prev) {
            prev.addEventListener('click', () => {
                const url = new URL(window.location.href);
                const page = parseInt(url.searchParams.get("page") || "1", 10);
                url.searchParams.set("page", Math.max(1, page - 1));
                window.location.href = url.toString();
            });
        }

        if (next) {
            next.addEventListener('click', () => {
                const url = new URL(window.location.href);
                const page = parseInt(url.searchParams.get("page") || "1", 10);
                url.searchParams.set("page", page + 1);
                window.location.href = url.toString();
            });
        }
    };

    // Normal form submissions refresh the page
    const handleSubmitFilters = scope => {
        scope.querySelectorAll('[data-filter-text-submit]').forEach(button => {
            button.addEventListener("click", () => {
                const form = button.closest("form");
                if (form) form.submit();
            });
        });

        scope.querySelectorAll('input[type="radio"], input[type="checkbox"], select').forEach(field => {
            field.addEventListener("change", () => {
                const form = field.closest("form");
                const submitFooter = form.querySelector(".filter-group__wrapper__footer");
                if (form && (!submitFooter || getComputedStyle(submitFooter).display === "none")) {
                    form.submit();
                }
            });
        });
    };

    const initBlock = scope => {
        handleToggleOverlays(scope);
        bindPaging(scope);
        handleSubmitFilters(scope);

        if (scope.querySelector('[data-results-map]')) {
            handleMapToggle(scope);
        }
    };

    return { initBlock };

})();

ControlBinders.register('[data-search-results]', el => searchResultsBlock.initBlock(el));
